import {Component, Input} from '@angular/core';
import {FirebaseService} from '../app/firebase.service';
import {RechnungItems} from '../app/types';
import {debounceTime} from 'rxjs/operators';
import {GruppenBuchung} from "./buchung";

@Component({
  selector: 'app-rechnung',
  templateUrl: './rechnung.component.html',
  styles: []
})
export class RechnungComponent {
  alleItems: RechnungItems;
  private subscription;

  constructor(public service: FirebaseService) {
  }

  @Input()
  set buchung(buchung: GruppenBuchung) {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    this.subscription = buchung.rechnungChanged.pipe(debounceTime(100))
      .subscribe(() => {
        this.alleItems = buchung.rechnung ? buchung.rechnung.alleItems : null;
      });
  }
}
